export default __webpack_public_path__ + "static/kingac-b2bd8039b8e6ac82990c9a961645681b.png";